import cn from 'classnames';
import * as React from 'react';

import { SocialIconProps } from '../types';

import s from './MaxIcon.module.scss';

export const MaxIcon: React.FC<SocialIconProps> = React.memo(({ view, className }) => {
  return (
    <svg
      className={cn(s.vkIcon, s[`vk-icon_${view}`], className)}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className={s.vkIcon__background} cx="16" cy="16" r="16" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7494 22.9042C12.6683 22.8466 12.5567 22.8622 12.4888 22.9349C11.5809 23.9069 9.25751 24.5887 9.15108 23.2621C9.15108 22.2227 8.91851 21.3468 8.66246 20.3824C8.34885 19.2013 8 17.8875 8 15.9779C8 11.4244 11.7201 8 16.1309 8C20.5417 8 24 11.5916 24 16.0221C24 20.4526 20.4316 23.9558 16.1727 23.9558C14.6617 23.9558 13.9284 23.7422 12.7494 22.9042ZM16.2546 11.9481C14.1614 11.8379 12.5279 13.296 12.1677 15.5781C11.8694 17.468 12.3983 19.7708 12.8507 19.8867C13.0425 19.9359 13.5043 19.5813 13.8402 19.2633C13.9034 19.2036 13.9988 19.1935 14.0729 19.239C14.5966 19.5604 15.1894 19.802 15.8431 19.8364C17.992 19.9495 19.8964 18.2612 20.0089 16.1038C20.1215 13.9464 18.4036 12.0612 16.2546 11.9481Z"
        fill="currentColor"
      ></path>
    </svg>
  );
});
